import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterByCity'
})

export class FilterByCity implements PipeTransform {
    transform(items: any[], args: Array<string>[]): any {
        if(!items || !args || args.length < 1){
            return items;
        }
        return items.filter(item => {
            for (var index = 0; index < args.length; index++) {
                var element = args[index].toString();
                if(element != "all"){
                    if(item.acronym == element) return true;
                }else{
                    if(item.acronym != "BCN") return true;
                }
            }  
        });
        
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/filter-city.pipe.ts